import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import { listAccounts, setSelectedAccount } from '../../actions/superadmin';
import AccountOrdersPage from './AccountOrdersPage';
import Loading from '../shared/Loading';

export class AccountOrdersPageContainer extends Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    listAccountsAction: PropTypes.func.isRequired,
    progress: PropTypes.number.isRequired,
    setSelectedAccountAction: PropTypes.func.isRequired,
    selectedAccount: PropTypes.object,
  };

  static defaultProps = {
    selectedAccount: undefined,
  };

  state = { activeLink: null };

  componentWillMount = () => {
    const { listAccountsAction } = this.props;
    const token = storeWithExpiration.get('token');
    listAccountsAction(token);
  };

  componentWillReceiveProps = nextProps => {
    const { accounts, selectedAccount } = nextProps;
    accounts.forEach((account, key) => {
      if (selectedAccount && account.get('id') === selectedAccount.get('id')) {
        this.setState({ activeLink: key });
      }
    });
  };

  handleAccountSelect = (account, key, evt) => {
    evt && evt.preventDefault();
    const { setSelectedAccountAction } = this.props;
    this.setState({ activeLink: key });
    setSelectedAccountAction(account);
  };

  render() {
    const { accounts, progress, selectedAccount } = this.props;
    const { activeLink } = this.state;
    const isLoaded = progress < 1 || (accounts !== undefined && accounts.size > 0);

    return isLoaded ? (
      <AccountOrdersPage
        activeLink={activeLink}
        accounts={accounts}
        handleAccountSelect={this.handleAccountSelect}
        selectedAccount={selectedAccount}
      />
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = state => {
  const { progress, superadmin } = state;
  const accounts = superadmin.get('accounts').rest();
  const selectedAccount = superadmin.get('selectedAccount');
  return {
    accounts,
    progress,
    selectedAccount,
  };
};

export default connect(mapStateToProps, {
  listAccountsAction: listAccounts,
  setSelectedAccountAction: setSelectedAccount,
})(AccountOrdersPageContainer);
